var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ColumnTotalVisibility } from '@shared/utils/Table/TableColumn.interface';
import { ExpandCollapseArrow } from '../../ExpandCollapseArrow/ExpandCollapseArrow';
import { TableCellText } from '../Cells/TableCellText';
import { TableCellTextStyle } from '../Cells/TableCellTextStyle';
import { useTableTotals } from '../Hooks/useTableTotals';
import { ColumnAlignmentStyles } from '../Table.interface';
export const TableBodyGroupRow = (_a) => {
    var { ref = null, tableTotalsService, columns, groupColumn, columnsWidth, row, isCollapsed, isShowTotals, subscribeTableUpdate, onRowClick, onRowKeyDown, onCellKeyDown } = _a, restProps = __rest(_a, ["ref", "tableTotalsService", "columns", "groupColumn", "columnsWidth", "row", "isCollapsed", "isShowTotals", "subscribeTableUpdate", "onRowClick", "onRowKeyDown", "onCellKeyDown"]);
    const { formattedTotals } = useTableTotals(ColumnTotalVisibility.Groups, tableTotalsService, columns, row.children, isShowTotals, subscribeTableUpdate);
    const renderTableBodyGroupCell = (column, isGroupColumn) => {
        var _a, _b;
        if (!isGroupColumn && groupColumn === column) {
            return null;
        }
        const classNames = ['table-body-cell', 'group', ColumnAlignmentStyles[column.alignment]];
        const className = classNames.join(' ');
        const id = row.id + column.id;
        const width = (_a = columnsWidth.get(column.id)) !== null && _a !== void 0 ? _a : column.defaultWidth;
        let text = '';
        if (isGroupColumn) {
            text = row.data.getFormattedValue(column.id);
        }
        else {
            text = (_b = formattedTotals.get(column.id)) !== null && _b !== void 0 ? _b : '';
        }
        const Tag = (isGroupColumn ? 'th' : 'td');
        return (_jsxs(Tag, { className: className, tabIndex: -1, "data-testid": id, style: { flex: width }, scope: isGroupColumn ? 'row' : undefined, "aria-expanded": isGroupColumn ? isCollapsed !== true : undefined, "aria-haspopup": isGroupColumn ? 'listbox' : undefined, onKeyDown: (e) => onCellKeyDown(e, column), children: [isGroupColumn && _jsx(ExpandCollapseArrow, { isExpanded: isCollapsed !== true }), _jsx(TableCellText, { style: TableCellTextStyle.Default, text: text, disabled: false })] }, id));
    };
    const className = ['table-body-row', 'group', isCollapsed ? 'collapsed' : 'expanded'].filter(Boolean).join(' ');
    return (_jsxs("tr", Object.assign({ ref: ref, className: className, tabIndex: 0, onClick: onRowClick, onKeyDown: onRowKeyDown }, restProps, { children: [groupColumn !== null && renderTableBodyGroupCell(groupColumn, true), columns.map((column) => renderTableBodyGroupCell(column, false))] })));
};
